import React from 'react';
import { Dropdown } from 'react-bootstrap';

import CardDropdown from 'components/common/CardDropdown';


const CertificateColumns = (handleOpenCertification, handleDownloadReport, handleShowCertificate, handleDeleteCertificate) => [
    {
        accessor: 'index',
        Header: '#',
        headerProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' }
        },
        cellProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' }
        },
        Cell: rowData => {
            const { index } = rowData.row.original;
            return index+1;
        }
    },
    {
        accessor: 'none',
        Header: '',
        disableSortBy: true,
        headerProps: {
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' }  // Ancho pequeño para el ícono del dropdown
        },
        cellProps: {
            className: 'text-end',
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' }  // Ancho pequeño para el ícono del dropdown
        },
        Cell: rowData => {
            const { certification_id, name, email, total_score, level, completed_date, certification_type, college } = rowData.row.original;
            return (
                <CardDropdown>
                    <div className="py-2">
                        <Dropdown.Item onClick={() => handleOpenCertification(certification_id,name, email, total_score, level, completed_date, college, certification_type)}>Ver Examen</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownloadReport(certification_id, email, name)}>Descargar Reporte</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleShowCertificate(certification_id, name, email, total_score, level, completed_date)}>Ver Certificado</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger" onClick={() => handleDeleteCertificate(certification_id, name)}>Eliminar</Dropdown.Item>
                    </div>
                </CardDropdown>
            );
        }
    },
    { 
        accessor: 'certification_id', 
        Header: 'ID',
        headerProps: { className: 'hidden-column' },
        cellProps: {
              className: 'hidden-column'
        },
    },
    { 
        accessor: 'name', 
        Header: 'Nombre',
        headerProps: {
            style: { width: '200px', minWidth: '200px', maxWidth: '300px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '200px', minWidth: '200px', maxWidth: '300px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'email', 
        Header: 'Email',
        headerProps: {
            style: { width: '250px', minWidth: '250px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '250px', minWidth: '250px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'college', 
        Header: 'Colegio',
        headerProps: {
            style: { width: '200px', minWidth: '200px', maxWidth: '250px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '200px', minWidth: '200px', maxWidth: '250px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'assigned_date', 
        Header: 'Asignación',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'completed_date', 
        Header: 'Finalizado',
        headerProps: {
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'certification_type', 
        Header: 'Tipo',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'total_score', 
        Header: 'Puntaje Total',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'total_percentage', 
        Header: 'Porcentaje Total',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'level', 
        Header: 'Nivel',
        headerProps: {
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'section_1', 
        Header: 'Section I',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'percentage_section_1', 
        Header: 'Porcentaje Section I',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'section_2', 
        Header: 'Section II',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'percentage_section_2', 
        Header: 'Porcentaje Section II',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'section_3', 
        Header: 'Section III',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'percentage_section_3', 
        Header: 'Porcentaje Section III',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'section_4', 
        Header: 'Section IV',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'percentage_section_4', 
        Header: 'Porcentaje Section IV',
        headerProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '100px', maxWidth: '100px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    }
];

export default CertificateColumns;